import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'primereact/panel';
import DimensionMatchResult from './DimensionMatchResult';
import { AbilityRangeGenerator } from '../../../../utils/AssessmentUtil';

const MatchingResultPanel = ({
  selectedJobId,
  selectedJob,
  displayResult,
  isMatchingResultLoaded,
  selectedStandardJob,
  jobProfileMatchResults,
  respondent,
}) => {
  const customJobMatch = (selectedJobId
    && selectedJob
    && displayResult
     && isMatchingResultLoaded
     && jobProfileMatchResults);

  const standardJobMatch = (
    selectedStandardJob
      && displayResult
       && isMatchingResultLoaded
       && jobProfileMatchResults);

  if (customJobMatch || standardJobMatch) {
    const {
      overallMatch,
      distortionResults,
      behaviorSectionMatchResults,
      cognitiveSectionMatchResults,
      interestsSectionMatchResults,
    } = jobProfileMatchResults;

    const jobProfile = selectedJob || selectedStandardJob;

    const dimensionMatchResult = (
      <DimensionMatchResult
        jobProfile={jobProfile}
        respondent={respondent}
        behaviorMatch={behaviorSectionMatchResults}
        distortionResults={distortionResults}
        cognitiveMatch={cognitiveSectionMatchResults}
        interestMatch={interestsSectionMatchResults}
      />
    );

    return (
      <div className="p-grid mt10">
        <div className="p-col-12">
          <Panel
            header={(
              <div className="p-grid p-nogutter">
                <div className="p-col">
                  <FormattedMessage id="assessment.matchingResults" defaultMessage="Matching Results" />
                  {` - ${jobProfile.name}`}
                </div>
                <div className="p-col-2 align-right">
                  <span className={`label pull-right ${AbilityRangeGenerator.mapOverallLabelToPercent(overallMatch)}`}>
                    {`${overallMatch} %`}
                  </span>
                </div>
              </div>
            )}
          >
            {dimensionMatchResult}
          </Panel>
        </div>
      </div>
    );
  }

  return <></>;
};

MatchingResultPanel.propTypes = {
  selectedJobId: PropTypes.string.isRequired,
  selectedJob: PropTypes.objectOf(PropTypes.any).isRequired,
  displayResult: PropTypes.bool.isRequired,
  isMatchingResultLoaded: PropTypes.bool.isRequired,
  selectedStandardJob: PropTypes.objectOf(PropTypes.any).isRequired,
  jobProfileMatchResults: PropTypes.objectOf(PropTypes.any).isRequired,
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default MatchingResultPanel;
